// extracted by mini-css-extract-plugin
export var isPrintedCell = "_yh-1";
export var printerIcon = "_yh-0";